//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DIC from '@/index/dictionary'
import InventorySub from './components/inventorySub'
import { Message } from 'element-ui'
export default {
  components:{
    InventorySub
  },
  data() {
    return {
      shopName:'',
      tableData:[],
      checkDialogState:false,
      checkDialogTable:false,
      accountArrValue:'老板1234',//选择接受账号初始值
      accountArr:[
        {value:1234,label:'老板'},
        {value:12345,label:'老板1'},
      ],
      orderStatusList:[
        {value:'未发送',label:'未发送'},
        {value:'已发送',label:'已发送'},
        {value:'已到货',label:'已到货'},
      ],
      orderStatus:'未发送',
      loading:false,
      DIC:DIC,
      compile:false,
      pageSizes:[5, 10, 15, 20],
      pageSizeValue:5,
      total:0,
      pageNo:1,
      managerList:[],
      manager:'全部',
      shopList:[],
      selectManager:'全部'
    }
  },
  mounted () {
    // this.handleLoadTableData11()
    this.info()
  },
  methods: {
    info(state=false){
      if(state){
        this.pageNo = 1
      }
      let data = {
        pageNo:this.pageNo,
        pageSize:this.pageSizeValue,
        dealerId:window.sessionStorage.getItem('dealerId'),
      }
      if(this.shopName !== '')
      data.shopName = this.shopName
      if(this.DStaffId !== '全部')
      data.shopName = this.shopName
      if(this.manager !== '全部' && this.orderStatus !== '未发送')
      data.dStaffId = this.manager
      this.managerList = []
      this.shopList = []
      this.total = 0
      // this.tableData = []
      data.orderStatus = this.orderStatus==='未发送'?0:this.orderStatus==='已发送'?1:2
      this.$axios.post('/mtea/stock/dealer/orderSearch', data).then(res => {
        this.managerList = res.staffList
        this.managerList.unshift({dStaffId:'全部',dStaffName:'全部'})
        this.shopList = res.shopList
        this.total = res.orderList.total
        res.orderList.records.forEach(e => {
          e.itemList.forEach(sub=>{
            sub.goodsExtra = JSON.parse(sub.goodsExtra)
          })
          res.staffList.forEach(sub => {
            if(sub.dStaffId === e.dealerId){
              e.dealerText =  sub.dStaffName
              e.dealerPhone =  sub.dStaffPhone
            }
          });
          if(!e.dShopId){
            e.shopMsg = {
              createTime: e.createTime,
              dShopAddress: e.address,
              dShopArea: e.area,
              dShopCity: e.city,
              dShopLinkman: e.userName,
              dShopName: e.shopName,
              dShopPhone: e.userPhone,
              dShopProvince: e.province,
              dealerId: e.dealerId
            }
          }else{
            res.shopList.forEach(sub => {
              if(sub.dShopId === e.dShopId){
                e.shopMsg =  sub
              }
            });
          }
        });
        this.tableData = res.orderList.records
        console.log(this.tableData)
      })
    },
    checkFun(data){
      this.checkDialogState = true
      // this.selectManager = data.dealerId  默认黄先生
      this.checkDialogTable = data
      console.log(data)
    },
    invSubState(){
      this.compile = false
    },
    sizeChange(num){
      this.pageSizeValue = num
      this.info()
    },
    currentChange(num){
      this.pageNo = num
      this.info()
    },
    addOrder(){
      this.$router.push({name:'addOrder'})
    },
    sendGoods(){
      if(this.selectManager === '全部'){
        this.$message.error('请先选择业务经理')
        return
      }
      let data = {
        dStaffId:this.selectManager,
        dealerId:window.sessionStorage.getItem('dealerId'),
        orderId:this.checkDialogTable.sAdminDealerOrderId
      }
      this.$axios.post('/mtea/stock/dealer/doPushOrder', data).then(res=>{
        console.log(res)
        this.$message({
          message: '保存成功',
          type: 'success'
        });
        this.checkDialogTable = false
        this.checkDialogState = false
        this.info(true)
      })
    }
  },
}
